module.exports = __webpack_public_path__ + "img/music-player-play-circle.ee1f3f68.svg";